export default "__VITE_ASSET__Bxr_hFy___"